import MuiThemeProvider from "components/MuiThemeProvider";
import PageInfoCardAdornment from "components/Layout/PageInfoCardAdornment";
import GroupsInfoCard from "../GroupsInfoCard";
import Constants from "config/Constants";
import { useTranslation } from "react-i18next";

function GroupsInfoCardAdornment() {
  const { t } = useTranslation();
  return (
    <PageInfoCardAdornment pageTitle={t(Constants.routes.groups.titleKey)}>
      {(props) => (
        <MuiThemeProvider>
          <GroupsInfoCard onClose={props.onClose} />
        </MuiThemeProvider>
      )}
    </PageInfoCardAdornment>
  );
}

export default GroupsInfoCardAdornment;
